import { useIntl } from 'react-intl';
import { Grid, Typography } from '@mui/material';
import { useLanguage } from '../../LanguageContext';

const InfoCard = ({
	name,
	role,
	logo,
	logoAlt,
	countryFlag,
	languages,
	profileImg,
	profileImgAlt,
	mobile,
	// email,
	location,
	extra,
	description,
}) => {
	const { $t } = useIntl();
	const { locale } = useLanguage();

	const contacts = [
		{
			href: `https://wa.me/+${mobile}`,
			image: '/assets/Images/whatsapps.svg',
			size: '16px',
		},
		{
			href: `tel:+${mobile}`,
			image: '/assets/Images/icon_call.png',
			size: '14px',
		},
		{
			href: `https://t.me/+${mobile}`,
			image: '/assets/Images/Telegram_Black.svg',
			size: '16px',
		},
	];

	return (
		<Grid
			borderRadius={'6px'}
			overflow={'hidden'}
			boxShadow={'2px 4px 15px 0px #00000026'}
			color={'#444A5D'}
			border={`2px solid rgba(255, 191, 63)`}
			bgcolor={'#FFEFD0'}
		>
			<Grid
				className="img-box"
				bgcolor={'white'}
				padding={'6px'}
				maxHeight={'200px'}
				width={'100%'}
				style={{
					aspectRatio: '5/3',
				}}
			>
				<img
					src={logo}
					alt={logoAlt}
					style={{
						objectFit: 'contain',
					}}
				/>
			</Grid>
			<Grid
				display={'grid'}
				gap={'16px'}
				padding={'10px'}
				marginTop={'-50px'}
			>
				<Grid
					display={'flex'}
					alignItems={'end'}
					justifyContent={'space-between'}
				>
					<Grid
						className="img-box"
						width={'100px'}
						height={'100px'}
						borderRadius={'50%'}
						border={'3px solid white'}
					>
						<img
							src={profileImg}
							alt={profileImgAlt}
						/>
					</Grid>
					<Grid
						className="img-box"
						width={'50px'}
						height={'50px'}
						borderRadius={'50%'}
						border={'2px solid white'}
					>
						<img
							src={countryFlag}
							alt='flag'
						/>
					</Grid>
				</Grid>
				<Grid
					display={'grid'}
					gap={'4px'}
					height={'max-content'}
				>
					<Typography
						fontSize={'24px'}
						lineHeight={'26px'}
					>
						{name}
					</Typography>
					{role && (
						<Typography
							fontSize={'18px'}
							lineHeight={'23px'}
						>
							{role}
						</Typography>
					)}
				</Grid>
				{languages && (
					<>
						<Grid
							display={'grid'}
							gap={'6px'}
						>
							<Typography fontSize={'14px'}> {$t({ id: 'languages' })}: </Typography>
							<Grid
								display={'flex'}
								alignItems={'center'}
								gap={'8px'}
								flexWrap={'wrap'}
							>
								{languages.map((language, index) => (
									<Typography
										key={index}
										fontSize={'14px'}
									>
										{language}
									</Typography>
								))}
							</Grid>
						</Grid>
						<Divider />
					</>
				)}
				<Grid
					display={'grid'}
					gap={'6px'}
				>
					<Typography fontSize={'14px'}> {$t({ id: 'contactInfo' })}: </Typography>
					{/* <Grid
						display={'flex'}
						alignItems={'center'}
						gap={'10px'}
					>
						<Grid
							className="img-box"
							width={'12px'}
							height={'10px'}
						>
							<img
								src="/assets/Images/email_black.svg"
								alt="email"
							/>
						</Grid>
						<Typography
							variant="span"
							fontSize={'16px'}
							lineHeight={'16px'}
							pt={'2px'}
						>
							{email}
						</Typography>
					</Grid> */}
					{contacts.map((contact, index) => (
						<Grid
							display={'grid'}
							gridTemplateColumns={'16px 1fr'}
							alignItems={'center'}
							gap={'10px'}
							key={index}
						>
							<Grid
								className="img-box"
								width={contact.size}
								height={contact.size}
							>
								<img
									src={contact.image}
									alt="mobile"
								/>
							</Grid>
							<Typography
								variant="span"
								fontSize={'16px'}
								lineHeight={'16px'}
								pt={'2px'}
							>
								<a
									href={contact.href}
									style={{
										color: '#444A5D',
									}}
									target="_blank"
									rel="noreferrer"
								>
									{`${locale !== 'fa' ? '+' : ''} ${mobile} ${
										locale === 'fa' ? '+' : ''
									}`}
								</a>
							</Typography>
						</Grid>
					))}
					{location && (
						<Grid
							display={'flex'}
							alignItems={'center'}
							gap={'10px'}
						>
							<Grid
								className="img-box"
								width={'16px'}
								height={'16px'}
							>
								<img
									src="/assets/Images/Location_Black.svg"
									width={'100%'}
									height={'100%'}
									style={{
										objectFit: 'contain',
									}}
									alt="mobile"
								/>
							</Grid>
							<Typography
								variant="span"
								fontSize={'14px'}
								lineHeight={'14px'}
								pt={'2px'}
							>
								{location}
							</Typography>
						</Grid>
					)}
					{extra && (
						<Typography
							fontSize={'14px'}
							fontWeight={'bold'}
							mr={'20px'}
						>
							{extra}
						</Typography>
					)}
				</Grid>
				{description && (
					<>
						<Divider />
						<Grid
							display={'grid'}
							gap={'5px'}
						>
							<Typography fontSize={'14px'}>{$t({ id: 'description' })}:</Typography>
							{description.map((d, index) => (
								<Typography
									key={index}
									fontSize={'14px'}
									textAlign={'justify'}
								>
									{d}
								</Typography>
							))}
						</Grid>
					</>
				)}
			</Grid>
		</Grid>
	);
};

const Divider = () => {
	return (
		<Grid
			height={'1px'}
			width={'100%'}
			borderBottom={'1px solid #444A5D'}
		></Grid>
	);
};

export default InfoCard;
